/* Liberty Club — motion engine (reveals + 3D tilt). Vanilla, ~1.5KB, respects reduced motion. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* --- Staggered scroll reveals --- */
  var revealTargets = document.querySelectorAll(
    '.card-wrapper, .lc-colcard, .lc-tst__card, .lc-vipgate__card, .multicolumn-list__item, .lc-story__content, .lc-story__img, .lc-vip__body > *, .lc-about__value'
  );
  if ('IntersectionObserver' in window && revealTargets.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var el = e.target;
          var siblings = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
          el.style.transitionDelay = Math.min(siblings * 70, 420) + 'ms';
          el.classList.add('lc-in');
          io.unobserve(el);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    revealTargets.forEach(function (el) { el.classList.add('lc-reveal'); io.observe(el); });
  }

  /* --- 3D tilt with glare on product/collection cards --- */
  var fine = window.matchMedia('(pointer: fine)').matches;
  if (!fine) return;
  document.querySelectorAll('.card-wrapper .card, .lc-colcard').forEach(function (card) {
    card.classList.add('lc-tilt');
    var glare = document.createElement('span');
    glare.className = 'lc-tilt__glare';
    card.appendChild(glare);
    var raf = null;
    card.addEventListener('mousemove', function (ev) {
      var r = card.getBoundingClientRect();
      var px = (ev.clientX - r.left) / r.width - 0.5;
      var py = (ev.clientY - r.top) / r.height - 0.5;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        card.style.transform = 'perspective(900px) rotateY(' + (px * 7) + 'deg) rotateX(' + (py * -7) + 'deg) translateZ(0)';
        glare.style.opacity = '1';
        glare.style.background = 'radial-gradient(420px circle at ' + ((px + 0.5) * 100) + '% ' + ((py + 0.5) * 100) + '%, rgba(255,255,255,0.22), transparent 55%)';
      });
    });
    card.addEventListener('mouseleave', function () {
      if (raf) cancelAnimationFrame(raf);
      card.style.transform = '';
      glare.style.opacity = '0';
    });
  });
})();
